import * as constants from "./thunkActionConstants";

export function createThunkActionCreator(type, promiseCreator) {
  return function thunkActionCreator() {
    const args = arguments;

    return dispatch => {
      dispatch({
        type,
        args,
        status: constants.ACTION_STATUS_PENDING
      });

      return promiseCreator.apply(this, args).then(
        result =>
          dispatch({
            type,
            status: constants.ACTION_STATUS_SUCCESS,
            payload: result
          }),
        error => dispatch({ type, status: constants.ACTION_STATUS_FAIL, error })
      );
    };
  };
}



// WEBPACK FOOTER //
// ./src/utils/redux/createThunkActionCreator.js